<template>
	<div>
		<EmptyState v-if="uploadedFileLists.length === 0" kind="documents" title="هیچ فایلی وجود ندارد" />
		<div v-else class="action-list">
			<div class="box">
				<Tableview
					:hover="true"
					:bordered="true"
					:showNoContent="showContnetFunc"
					:showNoData="showDataFunc"
				>
					<template #TableTitle>
						<tr>
							<th>ردیف</th>
							<th>نوع فایل</th>
							<th>نام</th>
							<th>آیکون</th>
							<th>لینک فایل</th>
							<th>عملیات</th>
						</tr>
					</template>

					<template #TableBody>
						<tr v-for="(item, index) in uploadedFileLists" :key="item.id">
							<td class="persian-number">
								{{ index + 1 }}
							</td>
							<td>
								<span v-if="item.type === 'EDU'">آموزش</span>
								<span v-if="item.type === 'ETC'">سایر</span>
							</td>
							<td>
								{{ item.name }}
							</td>
							<td>
                <RowActions :items="[{ label: 'مشاهده آیکون', icon: 'image', action: () => watchItems(item.icon) }]" />
              </td>
							<td>
                <RowActions :items="[{ label: 'مشاهده فایل', icon: 'file', action: () => watchItems(item.file) }]" />
              </td>
							<td>
                <RowActions :items="[{ label: 'ویرایش', icon: 'edit', action: () => editData(item) }, { label: 'حذف', icon: 'delete', action: () => deleteItemFunc(item.id), danger: true }]" />
              </td>
						</tr>
					</template>
				</Tableview>
				<!-- <div class="d-flex justify-content-end">
			<button @click="confirmItems" class="confirm-item">ثبت نهایی</button>
		</div> -->
			</div>
			<b-modal size="lg" v-model="editModal" hide-footer>
				<div class="d-flex mb-4">
					<div class="d-flex flex-column ml-3">
						<label for="html">نام</label>
						<input class="form-select" type="text" v-model="modalUserData.name" />
					</div>
					<div class="d-flex flex-column">
						<label for="html">ترتیب</label>
						<input class="form-select" type="text" v-model="modalUserData.priority" />
					</div>
				</div>
				<div class="mb-3">
					<label for="html">توضیحات</label>
					<textarea v-model="modalUserData.description" class="textarea"></textarea>
				</div>
				<div class="d-flex justify-content-end align-items-end">
					<button @click="editBtn" class="accept">تایید</button>
					<button class="remove-filtes" @click="editModal = false">بستن</button>
				</div>
			</b-modal>
			<b-modal v-model="deleteItemModal" hide-footer hide-header centered>
				<div class="p-3">
					<div>آیا از حذف خود اطمینان دارید؟</div>
					<div class="d-flex justify-content-end mt-4">
						<button @click="deleteItem" class="confirm-item">بله</button>
						<button @click="deleteItemModal = !deleteItemModal" class="reject-item">خیر</button>
					</div>
				</div>
			</b-modal>
		</div>
	</div>
</template>

<script>
import Tableview from '../../components/Tableview/index.vue';

import EmptyState from '@/components/EmptyState/index.vue';
import RowActions from '@/components/RowActions/index.vue';
export default {
	components: { RowActions, EmptyState,
		Tableview,
	},
	data() {
		return {
			uploadedFileLists: 0,
			deleteItemModal: false,
			ids: null,
			editModal: false,
			modalUserData: {},
		};
	},
	mounted() {
		this.getUploadedFile();
	},
	computed: {
		showContnetFunc() {
			return this.uploadedFileLists === 0;
		},
		showDataFunc() {
			if (this.uploadedFileLists.length !== undefined) {
				return this.uploadedFileLists.length === 0;
			}
			return false;
		},
	},
	methods: {
		async getUploadedFile() {
			const res = await this.$ApiServiceLayer.get(
				this.$PATH.RELATIVE_PATH.MULTI.UPLOAD_FILE +
					'?p=' +
					this.$STORE.state.userConfig.setProjectId,
				this.$PATH.SERVICE_NAME.EMPTY,
			);
			if (res.status === 200) {
				this.uploadedFileLists = res.data;
			}
		},
		watchItems(file) {
			file;
			window.open(file);
		},
		deleteItemFunc(ids) {
			this.deleteItemModal = !this.deleteItemModal;
			this.ids = ids;
		},
		editData(item) {
			this.editModal = true;
			this.modalUserData = { ...item };
			console.log(this.modalUserData);
		},
		async editBtn() {
			const data = {
				name: this.modalUserData.name,
				description: this.modalUserData.description,
				priority: this.modalUserData.priority,
			};
			const res = await this.$ApiServiceLayer.patch(
				this.$PATH.RELATIVE_PATH.MULTI.FILE_EDIT +
					this.modalUserData.id +
					'/' +
					'?p=' +
					this.$STORE.state.userConfig.setProjectId,
				this.$PATH.SERVICE_NAME.ORDER,
				data,
			);
			if (res.status === 200) {
				this.$notify({
					group: 'tc',
					type: 'success',
					text: 'تغییرات با موفقیت اعمال شد!',
				});
				this.getUploadedFile();
				this.editModal = false;
			}
		},
		async deleteItem() {
			const res = await this.$ApiServiceLayer.delete(
				this.$PATH.RELATIVE_PATH.MULTI.EDIT_UPLOAD_FILE + this.ids + '/' +
					'?p=' +
					this.$STORE.state.userConfig.setProjectId,
				this.$PATH.SERVICE_NAME.AUTH,
				{},
			);
			if (res.status === 204) {
				this.deleteItemModal = !this.deleteItemModal;
				this.$notify({
					group: 'tc',
					type: 'success',
					text: 'فایل با موفقیت حذف شد!',
				});
				this.getUploadedFile();
			}
		},
		// async confirmItems() {
		// 	const itemIds = this.uploadedFileLists.map((item) => item.id);
		// 	const res = await this.$ApiServiceLayer.post(
		// 		this.$PATH.RELATIVE_PATH.MULTI.BULK_UPDATE,
		// 		this.$PATH.SERVICE_NAME.AUTH,
		// 		{
		// 			is_active: true,
		// 			id: itemIds,
		// 		},
		// 	);
		// 	if (res.status === 200) {
		// 		this.$router.push({ name: 'newAction' });
		// 	}
		// },
	},
};
</script>
<style lang="scss" scoped>
.empty-container {
	display: flex;
	justify-content: center;
	align-items: center;
	height: 80vh;
}
.action-list {
	width: 100%;
	padding: 24px;
	min-height: 80vh;
	.box {
		margin-top: 16px;
		padding: 24px;
		border-radius: 8px;
		margin-bottom: 16px;
		background: var(--surface);
		border-radius: 8px;
		box-shadow: none;
	}
	.persian-number {
		font-family: 'IRANYekanfa' !important;
	}
	.watch-items {
		cursor: pointer;
	}
	.delete-icon {
		width: 32px;
	}
}
.form-select {
	width: 100%;
	border: 1px solid var(--line-strong);
	height: 38px;
	padding: 0 9px;
	border-radius: 8px;
	color: var(--text-3);
	border-radius: 8px;
}
.accept {
	height: 38px;
	background: var(--action);
	border-radius: 8px;
	color: var(--surface);
	border: none !important;
	margin-left: 10px;
	width: 100px;
	border-radius: 8px;
	padding: 0 16px;
	min-width: 64px;
}
.remove-filtes {
	padding: 0 16px;
	border: 1px solid var(--action);
	border-radius: 8px;
	color: var(--action);
	height: 38px;
	background: var(--surface);
	border-radius: 8px;
	min-width: 64px;
}
.textarea {
	border: 1px solid var(--line-strong);
	width: 100%;
	border-radius: 8px;
	min-height: 100px;
	padding: 10px;
}
.confirm-item {
	background: none;
	padding: 8px;
	border: 1px solid var(--action);
	border-radius: 8px;
	background: var(--action);
	color: var(--surface);
	margin-left: 8px;
	min-width: 75px;
}
.reject-item {
	border: 1px solid var(--action);
	background: var(--surface);
	color: var(--text);
	width: 75px;
	border-radius: 8px;
	color: var(--action);
	padding: 8px;
}
.eye-icon {
	width: 32px;
	cursor: pointer;
}
</style>
